import PropTypes from 'prop-types';

export default {
	propTypes: {
		actionButtons: PropTypes.object,
		rowHref: PropTypes.string,
		haveShowAction: PropTypes.bool,

		createActionButton: PropTypes.object,
		showActionButton: PropTypes.object,
		editActionButton: PropTypes.object,
		destroyActionButton: PropTypes.object
	},

	getDefaultProps () {
		return {
			actionButtons: {},
			rowHref: null,
			haveShowAction: false,
			createActionButton: {},
			showActionButton: {},
			editActionButton: {},
			destroyActionButton: {}
		};
	},

	getRowHref () {
		var rowHref = this.props.rowHref;
		var haveShowAction = this.props.haveShowAction;
		if(!haveShowAction || (!!rowHref && typeof rowHref == "string")) {
			return rowHref;
		}

		return this.getRestActionUrl('show');
	},

	getActionButtons: function() {
		if(this.props.readOnly) {
			return { member: [], collection: [] };
		}

		let objectReturn = {};
		let defaultActionButtonObject = this.getDefaultActionButtonsObject();

		Object
			.keys(defaultActionButtonObject)
			.forEach(gridActionKey => {
				objectReturn[gridActionKey] = this.mergeActionButtons(defaultActionButtonObject[gridActionKey], this.props.actionButtons[gridActionKey]);
			});

		return objectReturn;
	},

	mergeActionButtons (defaultObject, propsObject) {
		var propsActionButtons = this.props.actionButtons;
		var propsExtend = propsActionButtons.extend;
		var extendActionButtons = (typeof(propsExtend) == "boolean") ? propsExtend : false;

		if(extendActionButtons && Array.isArray(propsObject) && Array.isArray(defaultObject)) {
			return propsObject.concat(defaultObject);
		} else {
			return propsObject;
		}
	},

	getDefaultActionButtonsObject () {
		return {
			extend: true,
			member: this.getDefaultMemberActionButtons(),
			collection: this.getDefaultCollectionActionButtons()
		}
	},

	getDefaultMemberActionButtons () {
		var actions = [
			this.getDefaultEditActionProps(),
			this.getDefaultDestroyActionProps()
		];

		if(this.props.haveShowAction) {
			actions.unshift(this.getDefaultShowActionProps());
		}

		return actions;
	},

	getDefaultCollectionActionButtons () {
		return [this.getDefaultCreateActionProps()];
	},

	getDefaultCreateActionProps () {
		return Object.assign({}, {
			name: 'actions.new',
			context: 'none',
			href: this.getRestActionUrl('add')
		}, this.props.createActionButton);
	},

	getDefaultShowActionProps () {
		return Object.assign({}, {
			icon: 'search',
			href: this.getRestActionUrl('show')
		}, this.props.showActionButton);
	},

	getDefaultEditActionProps () {
		return Object.assign({}, {
			icon: 'edit',
			href: this.getRestActionUrl('edit')
		}, this.props.editActionButton);
	},

	getDefaultDestroyActionProps () {
		return Object.assign({}, {
			icon: 'destroy',
			method: this.getRestActionMethod('destroy'),
			actionUrl: this.getRestActionUrl('destroy'),
			confirmsWith: this.props.destroyConfirm
		}, this.props.destroyActionButton);
	}
}
